import { Injectable } from '@angular/core';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { AddCustomerVehicleResponseModel } from '../business-entities/add-customer-vehicle-model';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';

@Injectable({providedIn: 'root'})

export class AddCustomerVehicleDataService {
    constructor(
        private dataService: DataService
    ) {}

    getCustomerAndVehicleDetails(licensePlate: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetCustomerAndVehicleDetails, licensePlate).toPromise();
    }

    async getCustomerAndVehicleDetailsUsingMobile(mobileNo: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetCustomerVehiclesByMobileNo, mobileNo).toPromise();
    }
    async getCustomerListUsingMobile(mobileNo: string,AdvanceMobile:string,customerNo:string,firstName:string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetCustomerListByMobileNo, mobileNo,AdvanceMobile,customerNo,firstName).toPromise();
    }
    getBrandDetais(): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetBrandList).toPromise();
    }

    getCountryCodeAndMobileCodeDetails(): Promise<GenericResponse<any>>{
      return this.dataService.Get<GenericResponse<any>>(Urls.GetCountryCodeAndMobileCodeDetails).toPromise();
    }

    getFuelTypeDetails(): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetFuelTypeDetails).toPromise();
    }

    checkCustomerDetails(mobile: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.CheckCustomerAvailable, mobile).toPromise();
    }

    AddCustomerVehicleDetails(model: AddCustomerVehicleResponseModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.AddCustomerVehicleDetails, model).toPromise();
    }

    getVehicleDetailsFromDMSByVehicleno(vehicleNo: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.getVehicleDetailsFromDMSByVehicleno, vehicleNo).toPromise();
    }
}
